<style lang="less">
@import './login.less';
</style>

<template>
  <div class="login">
    <Row type="flex">
      <Col span="8">
        <img src="../../assets/images/login_bg.jpg" alt="" />
      </Col>
      <Col span="16">
        <div class="login-con">
          <Row type="flex" align="middle" justify="center" style="margin-bottom:30px;">
            <img class="logo" src="../../assets/images/logo.png" alt="" />
            <Col flex="1" class="logo-text">就业云企业平台</Col>
          </Row>
          <Card icon="log-in">
            <div class="form-con">
              <login-form></login-form>
            </div>
          </Card>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import LoginForm from '_c/login-form';
import { mapActions } from 'vuex';
import util from '@/libs/util';
export default {
  components: {
    LoginForm
  },
  methods: {
    ...mapActions(['handleLogin', 'getUserInfo']),
    handleSubmit({ identity, phone, code, type }) {
      this.handleLogin({ identity, phone, code, type }).then(res => {
        this.getUserInfo().then(res => {
          // util.timLogin(this.tim, true);
          // if (identity === "gonghui") {
          //   localStorage.setItem("mode", 2);
          //   this.getUnion();
          //   this.$router.push({
          //     name: "gonghuiShenheIndex"
          //   });
          // } else {
          //   localStorage.setItem("mode", 1);
          //   this.$router.push({
          //     name: "zhiweiIndex"
          //   });
          // }
          this.$router.push({
            name: 'zhiweiIndex'
          });
        });
      });
    },
    getUnion() {
      this.$axios.request({ url: 'api/union/index' }).then(res => {
        if (res.success) {
          let union = res.data;
          if (union && union.union_member.role_msg === '主管理员') {
            localStorage.setItem('superGonghui', 1);
          }
        }
      });
    }
  }
};
</script>
